import { getStrings } from '../../../Common/Localization/commonStrings';
const localizedStrings = {
    loadingSpinnerComponent: {
        strings: {
            en: {
                weAreWorking: "We're working on your request.",
                pleaseStandBy:"Please stand by."
            },
            es: {
                weAreWorking: "Estamos trabajando en su solicitud.",
                pleaseStandBy:"Por favor, espere."
            },
            ko: {
                weAreWorking: "귀하의 요청을 처리 중입니다.",
                pleaseStandBy:"잠시만 기다려 주십시오."
            },
            vi: {
                weAreWorking: "Chúng tôi đang xử lý yêu cầu của bạn.",
                pleaseStandBy:"Vui lòng chờ."
            },
            zh: {
                weAreWorking: "我们正在处理您的请求。",
                pleaseStandBy:" 请稍候。"
            } 
          },
          common: ['']
        }
    };

export const getLocalizedStrings = (componentName) => {
    app.logger.getLogger().info("Comp Name" + componentName);
    var strings = getStrings(localizedStrings[componentName].strings,
      localizedStrings[componentName].common, true);
      return strings;
  //  return new LocalizedStrings(strings);
  };
